export default __webpack_public_path__ + "static/media/perfect-polish.134136ee.png";